import styled from 'styled-components';
import { ReactComponent as EmptyTableMobileSvg } from 'src/assets/emptyMyTicketsTableMobile.svg';

export const EmptyTableWrapper = styled.div`
  position: relative;
  min-height: 100vh;
`;

export const EmptyContent = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
  align-items: center;
  padding-top: 80px;
  padding-bottom: 120px;
  padding-left: 45px;
  padding-right: 45px;
  text-align: center;
  width: 100%;
`;

export const EmptyIconWrapper = styled.div`
  width: auto;
  height: 230px;
`;

export const EmptyContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EmptyContentTitle = styled.h2`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const EmptyContentSubtitle = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const NoNotesIcon = styled(EmptyTableMobileSvg)`
  width: 100%;
  height: 100%;
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;
